import { useContext } from 'react';

import { XYChartAxesConfigContext } from '../context/axes/XYChartAxesConfig.context.js';

export const useAxesConfig = () => {
  const context = useContext(XYChartAxesConfigContext);

  if (context === undefined) {
    throw new Error(
      'useAxesConfig must be used within a XYChartAxesConfigContext',
    );
  }

  return context;
};
